export default __webpack_public_path__ + "static/img/16.20fc4a6.png";